module.exports = __webpack_public_path__ + "static/media/TPH.a7d1c6cf.png";